import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListItemCategory({
    loading,
    filteredCategories,
    selected,
    handleSelect,
    handleToggleStatus,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Item Category Name</th>
                        <th>Item Category Code</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="4" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredCategories.length > 0 ? (
                        filteredCategories.map((c) => {
                            const isActive = c.status === "Active";
                            return (
                                <tr key={c.id}>
                                    <td>
                                        <input
                                            type="radio"
                                            name="itemCategorySelect"
                                            disabled={c.status === "Inactive"}
                                            checked={selected === c.id}
                                            onChange={() => handleSelect(c.id)}
                                        />
                                    </td>
                                    <td>{c.itemCategoryName}</td>
                                    <td>{c.itemCategoryCode}</td>
                                    <td>
                                        <button
                                            type="button"
                                            className={`badge border-0 ${isActive ? "bg-success" : "bg-secondary"
                                                }`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleToggleStatus(c)}
                                        >
                                            {isActive ? "Active" : "Inactive"}
                                        </button>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4" className="text-center text-muted">
                                No item categories found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
